"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$DataTypeRequestDto = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
exports.$DataTypeRequestDto = {
    properties: {
        user_fullName: {
            type: 'string',
            description: `Full name of the user`,
            isRequired: true,
        },
        user_email: {
            type: 'string',
            description: `Email of the user`,
            isRequired: true,
        },
        user_avatar: {
            type: 'string',
        },
        navigationId: {
            type: 'string',
            isRequired: true,
        },
        class_event_id: {
            type: 'string',
            description: `Class id of the user is booked`,
        },
        class_event_name: {
            type: 'string',
            description: `Class name of the user is booked`,
        },
        space_id: {
            type: 'string',
        },
        space_name: {
            type: 'string',
        },
        space_imgUrl: {
            type: 'string',
        },
    },
};
